module.exports = __webpack_public_path__ + "img/79.e72b599f.jpg";